module.exports = __webpack_public_path__ + "img/24.a74c24e6.png";